import styled from "styled-components";

export const AGButton = styled.button`
	border-radius: 5px;
	border-radius: 5px;
	font-size: 1.07692rem;
	font-weight: 600;
	letter-spacing: 0px;
	opacity: 1;
	font-size: 0.875rem;
	width: auto;
	min-width: 50px;
	padding: 5px 15px;
	margin: 10px 10px 10px 0;
	&:hover,
	&:focus {
		background-color: rgb(218, 218, 218);
	}
	&.btn-cancel {
		align-items: center;
		display: flex;
		flex-wrap: nowrap;
		height: 100%;
		justify-content: center;
		vertical-align: baseline;
		width: 178px;
		height: 38px;
		color: black;
		margin-top: 20px;
		margin-bottom: 20px;
		background: #d9d9d9;

		&:hover {
			background: #a8a8a8;
		}
	}
`;

export const ModalHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 60px;
	border-bottom: 1px solid #cccccc;
	padding: 0px 15px;
	.title {
		font-size: 1rem;
		font-weight: 700;
	}
`;

export const ModalBody = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	.title {
		font-size: 1rem;
		font-weight: 700;
	}
	overflow-y: auto;
	position: relative;
	min-height: calc(100% - 120px);
	width: 100%;
`;

// export const ModalBodyAddProfile = styled.div`
// 	display: flex;
// 	align-items: center;
// 	justify-content: space-between;
// 	.title {
// 		font-size: 18px;
// 		font-weight: 700;
// 	}
// 	overflow-y: scroll;
// 	position: relative;
// 	height: 300px;
// 	width: 100%;
// `;

export const ModalFooter = styled.div`
	border-top: 1px solid #cccccc;
	padding: 0px 15px;
	display: flex;
	align-items: center;
	justify-content: end;
	gap: 10px;
	height: 60px;
`;

export const CloseIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	display: flex;
	cursor: pointer;
	border-radius: 50%;
	background: #58585b;
	color: #fff;
	&:hover {
		opacity: 0.9;
	}
`;
